// This file is auto-generated by @hey-api/openapi-ts

import {
  formDataBodySerializer,
  type Client,
  type Options as ClientOptions,
  type TDataShape,
} from '@hey-api/client-fetch'

import { client as _heyApiClient } from './client.gen'
import type {
  ArchiveProfileData,
  ArchiveProfileResponse,
  AuthorActionGenerateData,
  AuthorActionGenerateError,
  AuthorActionGenerateResponse,
  AuthorActionPossibleKeysData,
  AuthorActionPossibleKeysResponse,
  AuthorActionRationalesData,
  AuthorActionRationalesResponse,
  AuthorActionRegenerateData,
  AuthorActionRegenerateError,
  AuthorActionRegenerateResponse,
  AuthorActionSwitcherooData,
  AuthorActionSwitcherooError,
  AuthorActionSwitcherooResponse,
  AutosaveItemData,
  AutosaveItemError,
  AutosaveItemResponse,
  CheckUnsavedContentData,
  CheckUnsavedContentError,
  CheckUnsavedContentResponse,
  CleanupProfilesData,
  CloneItemData,
  CloneItemError,
  CloneItemResponse,
  ContinueExportJobData,
  ContinueExportJobError,
  ContinueExportJobResponse,
  CreateAiModelData,
  CreateAiModelError,
  CreateAiModelResponse,
  CreateFolderData,
  CreateFolderError,
  CreateFolderResponse,
  CreateOrUpdateProfileData,
  CreateOrUpdateProfileError,
  CreateUserData,
  CreateUserError,
  CreateUserResponse2,
  CreateWebhookConfigurationData,
  CreateWebhookConfigurationError,
  CreateWebhookConfigurationResponse,
  DeleteAiModelsData,
  DeleteAiModelsResponse,
  DeleteAuth0UsersData,
  DeleteAuth0UsersError,
  DeleteAuth0UsersResponse,
  DeleteFinetunesData,
  DeleteFinetunesError,
  DeleteFinetunesResponse,
  DeleteFolderData,
  DeleteFolderError,
  DeleteFolderResponse,
  DeleteUsersData,
  DeleteUsersError,
  DeleteUsersResponse,
  DeleteWebhookConfigurationData,
  DeleteWebhookConfigurationError,
  DeleteWebhookConfigurationResponse,
  DownloadExportedFileData,
  ExportItemsData,
  ExportItemsError,
  ExportItemsResponse,
  GenerateData,
  GenerateItemSetData,
  GenerateItemSetResponse,
  GenerateMathData,
  GenerateMathError,
  GenerateMathResponse,
  GenerateRationalesData,
  GenerateRationalesResponse,
  GenerateResponse,
  GenerateV2Data,
  GenerateV2Response,
  GetBatchItemsData,
  GetBatchItemsResponse,
  GetCustomerData,
  GetCustomerResponse,
  GetDraftFolderData,
  GetDraftFolderResponse,
  GetDraftStatsData,
  GetDraftStatsResponse,
  GetFolderData,
  GetFolderPermissionsData,
  GetFolderPermissionsError,
  GetFolderPermissionsResponse,
  GetFolderResponse,
  GetIntegrationData,
  GetIntegrationError,
  GetIntegrationResponse,
  GetItemByIdentifierData,
  GetItemByIdentifierResponse,
  GetItemMediaData,
  GetItemMediaError,
  GetItemMediaListData,
  GetItemMediaListResponse,
  GetItemMediaResponse,
  GetModelPermissionsData,
  GetModelPermissionsResponse,
  GetModelsOverviewData,
  GetModelsOverviewResponse,
  GetProfileByKeyData,
  GetProfileByKeyResponse,
  GetRecentItemsData,
  GetRecentItemsResponse,
  GetV2ItemData,
  GetV2ItemResponse,
  GetWebhookConfigurationData,
  GetWebhookConfigurationError,
  GetWebhookConfigurationResponse,
  GetWebhookDeliveryData,
  GetWebhookDeliveryError,
  GetWebhookDeliveryResponse,
  HealthzData,
  ImportExemplarsData,
  ImportExemplarsError,
  ImportExemplarsResponse,
  ImportFinetunesData,
  ImportFinetunesError,
  ImportFinetunesResponse,
  InternalCreateCustomerData,
  InternalCreateCustomerError2,
  InternalCreateCustomerResponse,
  InternalGetCustomerData,
  InternalGetCustomerResponse,
  InternalUpdateCustomerData,
  InternalUpdateCustomerResponse,
  ListAiModelsData,
  ListAiModelsProfilesAdminData,
  ListAiModelsProfilesAdminResponse,
  ListAiModelsResponse,
  ListExportJobsData,
  ListExportJobsResponse,
  ListFoldersBasicData,
  ListFoldersBasicResponse,
  ListFoldersData,
  ListFoldersResponse,
  ListWebhookConfigurationsData,
  ListWebhookConfigurationsError,
  ListWebhookConfigurationsResponse,
  ListWebhookDeliveriesData,
  ListWebhookDeliveriesError,
  ListWebhookDeliveriesResponse,
  LoginCallbackData,
  MoveFolderItemsData,
  MoveFolderItemsResponse,
  PossibleKeysData,
  PossibleKeysError,
  PossibleKeysResponse,
  PreValidateExportData,
  PreValidateExportError,
  PreValidateExportResponse,
  ProxyWolframImageData,
  QueryWolframData,
  RemoveFolderData,
  RemoveFolderError,
  RemoveFolderItemsData,
  RemoveFolderItemsResponse,
  RemoveFolderResponse,
  RenameBatchData,
  RenameBatchError,
  RenameBatchResponse,
  RenameFolderData,
  RenameFolderError,
  RenameFolderResponse,
  ResetCustomerDataData,
  ResetCustomerDataError,
  ResetCustomerDataResponse,
  ResetUserDataData,
  ResetUserDataError,
  ResetUserDataResponse,
  RunBiasCheckData,
  RunBiasCheckResponse,
  SaveItemData,
  SaveItemError,
  SaveItemResponse,
  SaveItemV2Data,
  SaveItemV2Error,
  SaveItemV2Response,
  SearchItemsData,
  SearchItemsResponse,
  SearchReferencesData,
  SearchReferencesError,
  SearchReferencesResponse,
  SwitchCustomerData,
  SwitchCustomerError,
  SwitchCustomerResponse,
  TestIntegrationData,
  TestIntegrationError,
  TestIntegrationResponse,
  UpdateAiModelFlagsData,
  UpdateAiModelFlagsError,
  UpdateAiModelFlagsResponse,
  UpdateContentVersionsData,
  UpdateContentVersionsError,
  UpdateContentVersionsResponse,
  UpdateFolderData,
  UpdateFolderPermissionsData,
  UpdateFolderPermissionsError,
  UpdateFolderPermissionsResponse,
  UpdateMetadataData,
  UpdateMetadataError,
  UpdateUserData,
  UpdateUserError,
  UpdateUserLastAccessData,
  UpdateUserLastAccessResponse,
  UpdateUserResponse,
  UpdateWebhookConfigurationData,
  UpdateWebhookConfigurationError,
  UpdateWebhookConfigurationResponse,
  UploadMediaToItemData,
  UploadMediaToItemError,
  UploadMediaToItemResponse,
  UpsertIntegrationData,
  UpsertIntegrationError,
  UpsertIntegrationResponse,
  UpsertModelPermissionsData,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Healthz
 */
export const healthz = <ThrowOnError extends boolean = false>(
  options?: Options<HealthzData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/healthz',
    ...options,
  })
}

/**
 * List Ai Models
 */
export const listAiModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiModelsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ListAiModelsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai-models',
    ...options,
  })
}

/**
 * Create Ai Model
 */
export const createAiModel = <ThrowOnError extends boolean = false>(
  options: Options<CreateAiModelData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAiModelResponse,
    CreateAiModelError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/ai-models',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * List Ai Models Profiles Admin
 * Get combined list of AI Models and optionally Profiles for admin permissions management.
 * Returns both entity types in a single list with additional metadata.
 * Profiles are included only if item_types_v2 feature flag is enabled.
 */
export const listAiModelsProfilesAdmin = <ThrowOnError extends boolean = false>(
  options?: Options<ListAiModelsProfilesAdminData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListAiModelsProfilesAdminResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai-models/admin',
    ...options,
  })
}

/**
 * Search References
 */
export const searchReferences = <ThrowOnError extends boolean = false>(
  options: Options<SearchReferencesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SearchReferencesResponse,
    SearchReferencesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai-models/{ai_model_id}/references',
    ...options,
  })
}

/**
 * Update Ai Model Flags
 */
export const updateAiModelFlags = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAiModelFlagsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UpdateAiModelFlagsResponse,
    UpdateAiModelFlagsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai-models/{internal_name}/update-flags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Model Permissions
 * Get all AI model and profile permissions for the current customer.
 */
export const getModelPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelPermissionsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetModelPermissionsResponse, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/ai-models/permissions',
      ...options,
    },
  )
}

/**
 * Upsert Model Permissions
 * Upsert model permissions for multiple users.
 * Creates new permissions or updates existing ones for either AI models or profiles.
 */
export const upsertModelPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpsertModelPermissionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai-models/permissions/upsert',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Models Overview
 */
export const getModelsOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetModelsOverviewData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetModelsOverviewResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/models-overview',
    ...options,
  })
}

/**
 * Author Action Rationales
 */
export const authorActionRationales = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionRationalesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AuthorActionRationalesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/rationales',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Autosave Item
 */
export const autosaveItem = <ThrowOnError extends boolean = false>(
  options: Options<AutosaveItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AutosaveItemResponse,
    AutosaveItemError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/autosave',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Author Action Generate
 * Trigger generation for an existing item, optionally targeting a specific part.
 *
 * This endpoint supports:
 * - Retry generation for failed items (whole-item retry when part_name is omitted)
 * - Generate specific composite parts (e.g., EBSR Part B)
 * - Optionally specify the item type for the part being generated (part_item_type)
 */
export const authorActionGenerate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionGenerateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AuthorActionGenerateResponse,
    AuthorActionGenerateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Author Action Regenerate
 */
export const authorActionRegenerate = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionRegenerateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AuthorActionRegenerateResponse,
    AuthorActionRegenerateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/regenerate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Update Metadata
 */
export const updateMetadata = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMetadataData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, UpdateMetadataError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/metadata/{metadata_group_internal_name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Author Action Switcheroo
 * Switch the variant of an MCQ item between SINGLE and MULTI.
 * This endpoint verifies the switcheroo is possible and starts a background task
 * to perform the variant switch. The item type's on_switcheroo method must be implemented.
 * The frontend should call this after confirming the variant switch with the user.
 */
export const authorActionSwitcheroo = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionSwitcherooData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AuthorActionSwitcherooResponse,
    AuthorActionSwitcherooError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/switcheroo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get V2 Item
 */
export const getV2Item = <ThrowOnError extends boolean = false>(
  options: Options<GetV2ItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetV2ItemResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{identifier}',
    ...options,
  })
}

/**
 * Author Action Possible Keys
 */
export const authorActionPossibleKeys = <ThrowOnError extends boolean = false>(
  options: Options<AuthorActionPossibleKeysData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AuthorActionPossibleKeysResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/{item_id}/actions/possible-keys',
    ...options,
  })
}

/**
 * Get Batch Items
 * Retrieve all items associated with a specific batch by batchId.
 */
export const getBatchItems = <ThrowOnError extends boolean = false>(
  options: Options<GetBatchItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetBatchItemsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/author/batch/{batch_id}/items',
    ...options,
  })
}

/**
 * Rename Batch
 * Rename batch by batch id
 */
export const renameBatch = <ThrowOnError extends boolean = false>(
  options: Options<RenameBatchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<RenameBatchResponse, RenameBatchError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/author/batch/{batch_id}/name',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  )
}

/**
 * List Folders
 */
export const listFolders = <ThrowOnError extends boolean = false>(
  options?: Options<ListFoldersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ListFoldersResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders',
    ...options,
  })
}

/**
 * Create Folder
 */
export const createFolder = <ThrowOnError extends boolean = false>(
  options: Options<CreateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateFolderResponse,
    CreateFolderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * List Folders Basic
 */
export const listFoldersBasic = <ThrowOnError extends boolean = false>(
  options?: Options<ListFoldersBasicData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ListFoldersBasicResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/list-basic',
    ...options,
  })
}

/**
 * Search Items
 */
export const searchItems = <ThrowOnError extends boolean = false>(
  options?: Options<SearchItemsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<SearchItemsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/list/search',
    ...options,
  })
}

/**
 * Get Item By Identifier
 */
export const getItemByIdentifier = <ThrowOnError extends boolean = false>(
  options: Options<GetItemByIdentifierData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetItemByIdentifierResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/item-by-identifier/{identifier}',
    ...options,
  })
}

/**
 * Pre Validate Export
 */
export const preValidateExport = <ThrowOnError extends boolean = false>(
  options: Options<PreValidateExportData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PreValidateExportResponse,
    PreValidateExportError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/pre-validate-export',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Folder Permissions
 */
export const getFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderPermissionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetFolderPermissionsResponse,
    GetFolderPermissionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}/permissions',
    ...options,
  })
}

/**
 * Update Folder Permissions
 */
export const updateFolderPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderPermissionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateFolderPermissionsResponse,
    UpdateFolderPermissionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}/permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Draft Folder
 */
export const getDraftFolder = <ThrowOnError extends boolean = false>(
  options?: Options<GetDraftFolderData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetDraftFolderResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/draft-items',
    ...options,
  })
}

/**
 * Get Draft Stats
 */
export const getDraftStats = <ThrowOnError extends boolean = false>(
  options?: Options<GetDraftStatsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetDraftStatsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/draft-items/stats',
    ...options,
  })
}

/**
 * Move Folder Items
 */
export const moveFolderItems = <ThrowOnError extends boolean = false>(
  options: Options<MoveFolderItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<MoveFolderItemsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/move-folder-items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Remove Folder Items
 */
export const removeFolderItems = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFolderItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<RemoveFolderItemsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/remove-folder-items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Delete Folder
 */
export const deleteFolder = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteFolderResponse,
    DeleteFolderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}',
    ...options,
  })
}

/**
 * Get Folder
 */
export const getFolder = <ThrowOnError extends boolean = false>(
  options: Options<GetFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetFolderResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}',
    ...options,
  })
}

/**
 * Update Folder
 * Move and/or rename given folder
 */
export const updateFolder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Rename Folder
 */
export const renameFolder = <ThrowOnError extends boolean = false>(
  options: Options<RenameFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    RenameFolderResponse,
    RenameFolderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/folders/{folder_id}/name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Customer
 */
export const getCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomerData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetCustomerResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/customer',
    ...options,
  })
}

/**
 * Download Exported File
 */
export const downloadExportedFile = <ThrowOnError extends boolean = false>(
  options: Options<DownloadExportedFileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/exports/{export_id}/download',
    ...options,
  })
}

/**
 * List Export Jobs
 */
export const listExportJobs = <ThrowOnError extends boolean = false>(
  options: Options<ListExportJobsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ListExportJobsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/exports',
    ...options,
  })
}

/**
 * Export Items
 */
export const exportItems = <ThrowOnError extends boolean = false>(
  options: Options<ExportItemsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ExportItemsResponse,
    ExportItemsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/exports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Continue Export Job
 */
export const continueExportJob = <ThrowOnError extends boolean = false>(
  options: Options<ContinueExportJobData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ContinueExportJobResponse,
    ContinueExportJobError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/exports/{export_id}/continue',
    ...options,
  })
}

/**
 * Delete Finetunes
 */
export const deleteFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFinetunesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteFinetunesResponse,
    DeleteFinetunesError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/finetunes/{parent_name}',
    ...options,
  })
}

/**
 * Import Finetunes
 */
export const importFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<ImportFinetunesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ImportFinetunesResponse,
    ImportFinetunesError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/finetunes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Integration
 */
export const getIntegration = <ThrowOnError extends boolean = false>(
  options: Options<GetIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntegrationResponse,
    GetIntegrationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/integrations/{integration_type}',
    ...options,
  })
}

/**
 * Upsert Integration
 */
export const upsertIntegration = <ThrowOnError extends boolean = false>(
  options: Options<UpsertIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UpsertIntegrationResponse,
    UpsertIntegrationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/integrations/{integration_type}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Test Integration
 */
export const testIntegration = <ThrowOnError extends boolean = false>(
  options: Options<TestIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    TestIntegrationResponse,
    TestIntegrationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/integrations/{integration_type}/test',
    ...options,
  })
}

/**
 * Delete Auth0 Users
 */
export const deleteAuth0Users = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAuth0UsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAuth0UsersResponse,
    DeleteAuth0UsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/gdpr_users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Reset Customer Data
 */
export const resetCustomerData = <ThrowOnError extends boolean = false>(
  options?: Options<ResetCustomerDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ResetCustomerDataResponse,
    ResetCustomerDataError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/reset-customer-data',
    ...options,
  })
}

/**
 * Delete Ai Models
 */
export const deleteAiModels = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAiModelsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<DeleteAiModelsResponse, unknown, ThrowOnError>({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/internal/customers/{customer_name}/ai-models',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Internal Get Customer
 */
export const internalGetCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<InternalGetCustomerData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<InternalGetCustomerResponse, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/internal/customers/self',
      ...options,
    },
  )
}

/**
 * Internal Update Customer
 */
export const internalUpdateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<InternalUpdateCustomerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InternalUpdateCustomerResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/customers/self',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Internal Create Customer
 */
export const internalCreateCustomer = <ThrowOnError extends boolean = false>(
  options: Options<InternalCreateCustomerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    InternalCreateCustomerResponse,
    InternalCreateCustomerError2,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/customers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Switch Customer
 */
export const switchCustomer = <ThrowOnError extends boolean = false>(
  options: Options<SwitchCustomerData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SwitchCustomerResponse,
    SwitchCustomerError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/switch-customers/{customer_id}',
    ...options,
  })
}

/**
 * Reset User Data
 */
export const resetUserData = <ThrowOnError extends boolean = false>(
  options?: Options<ResetUserDataData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    ResetUserDataResponse,
    ResetUserDataError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/internal/reset-user-data',
    ...options,
  })
}

/**
 * Cleanup Profiles
 * Internal endpoint to cleanup all profiles, exemplars, and their items.
 * Can only run in local, dev, qa environments.
 * Requires API key authentication.
 */
export const cleanupProfiles = <ThrowOnError extends boolean = false>(
  options?: Options<CleanupProfilesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/internal/cleanup/profiles',
    ...options,
  })
}

/**
 * Generate Item Set
 */
export const generateItemSet = <ThrowOnError extends boolean = false>(
  options: Options<GenerateItemSetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<GenerateItemSetResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/item-sets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Generate
 */
export const generate = <ThrowOnError extends boolean = false>(
  options: Options<GenerateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<GenerateResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Item Media List
 */
export const getItemMediaList = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaListData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetItemMediaListResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/media',
    ...options,
  })
}

/**
 * Upload Media To Item
 */
export const uploadMediaToItem = <ThrowOnError extends boolean = false>(
  options: Options<UploadMediaToItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UploadMediaToItemResponse,
    UploadMediaToItemError,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/media',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  })
}

/**
 * Get Item Media
 */
export const getItemMedia = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemMediaResponse,
    GetItemMediaError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/media/{media_id}',
    ...options,
  })
}

/**
 * Check Unsaved Content
 */
export const checkUnsavedContent = <ThrowOnError extends boolean = false>(
  options: Options<CheckUnsavedContentData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    CheckUnsavedContentResponse,
    CheckUnsavedContentError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/check-unsaved-content',
    ...options,
  })
}

/**
 * Update Content Versions
 */
export const updateContentVersions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateContentVersionsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateContentVersionsResponse,
    UpdateContentVersionsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Save Item V2
 */
export const saveItemV2 = <ThrowOnError extends boolean = false>(
  options: Options<SaveItemV2Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<SaveItemV2Response, SaveItemV2Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/v2/{item_id}/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Save Item
 */
export const saveItem = <ThrowOnError extends boolean = false>(
  options: Options<SaveItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<SaveItemResponse, SaveItemError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Clone Item
 */
export const cloneItem = <ThrowOnError extends boolean = false>(
  options: Options<CloneItemData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CloneItemResponse, CloneItemError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/clone',
    ...options,
  })
}

/**
 * Possible Keys
 */
export const possibleKeys = <ThrowOnError extends boolean = false>(
  options: Options<PossibleKeysData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    PossibleKeysResponse,
    PossibleKeysError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/possible-keys',
    ...options,
  })
}

/**
 * Generate Rationales
 */
export const generateRationales = <ThrowOnError extends boolean = false>(
  options: Options<GenerateRationalesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<GenerateRationalesResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/rationales',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Run Bias Check
 */
export const runBiasCheck = <ThrowOnError extends boolean = false>(
  options: Options<RunBiasCheckData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<RunBiasCheckResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/bias-check',
    ...options,
  })
}

/**
 * Generate Math
 */
export const generateMath = <ThrowOnError extends boolean = false>(
  options: Options<GenerateMathData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateMathResponse,
    GenerateMathError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/items/{item_id}/generate-math',
    ...options,
  })
}

/**
 * Login Callback
 */
export const loginCallback = <ThrowOnError extends boolean = false>(
  options?: Options<LoginCallbackData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: '/api/login-callback',
    ...options,
  })
}

/**
 * Remove Folder
 */
export const removeFolder = <ThrowOnError extends boolean = false>(
  options: Options<RemoveFolderData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    RemoveFolderResponse,
    RemoveFolderError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/projects/{id}',
    ...options,
  })
}

/**
 * Get Recent Items
 * Get the user's most recently modified items (max 6)
 */
export const getRecentItems = <ThrowOnError extends boolean = false>(
  options?: Options<GetRecentItemsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetRecentItemsResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/recent-items',
    ...options,
  })
}

/**
 * Update User Last Access
 */
export const updateUserLastAccess = <ThrowOnError extends boolean = false>(
  options?: Options<UpdateUserLastAccessData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).patch<
    UpdateUserLastAccessResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/update-last-access',
    ...options,
  })
}

/**
 * Delete Users
 */
export const deleteUsers = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteUsersResponse,
    DeleteUsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<CreateUserResponse2, CreateUserError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/users',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  )
}

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<UpdateUserResponse, UpdateUserError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/api/users/{user_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  )
}

/**
 * List Webhook Configurations
 */
export const listWebhookConfigurations = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookConfigurationsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListWebhookConfigurationsResponse,
    ListWebhookConfigurationsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/configurations',
    ...options,
  })
}

/**
 * Create Webhook Configuration
 */
export const createWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<CreateWebhookConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateWebhookConfigurationResponse,
    CreateWebhookConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/configurations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Delete Webhook Configuration
 */
export const deleteWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWebhookConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteWebhookConfigurationResponse,
    DeleteWebhookConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
  })
}

/**
 * Get Webhook Configuration
 */
export const getWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetWebhookConfigurationResponse,
    GetWebhookConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
  })
}

/**
 * Update Webhook Configuration
 */
export const updateWebhookConfiguration = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWebhookConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateWebhookConfigurationResponse,
    UpdateWebhookConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/configurations/{config_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Webhook Delivery
 */
export const getWebhookDelivery = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhookDeliveryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetWebhookDeliveryResponse,
    GetWebhookDeliveryError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/deliveries/{delivery_id}',
    ...options,
  })
}

/**
 * List Webhook Deliveries
 */
export const listWebhookDeliveries = <ThrowOnError extends boolean = false>(
  options?: Options<ListWebhookDeliveriesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ListWebhookDeliveriesResponse,
    ListWebhookDeliveriesError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/webhooks/deliveries',
    ...options,
  })
}

/**
 * Query Wolfram
 */
export const queryWolfram = <ThrowOnError extends boolean = false>(
  options: Options<QueryWolframData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/wolfram',
    ...options,
  })
}

/**
 * Proxy Wolfram Image
 */
export const proxyWolframImage = <ThrowOnError extends boolean = false>(
  options: Options<ProxyWolframImageData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/wolfram/proxy',
    ...options,
  })
}

/**
 * Import Exemplars
 */
export const importExemplars = <ThrowOnError extends boolean = false>(
  options: Options<ImportExemplarsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ImportExemplarsResponse,
    ImportExemplarsError,
    ThrowOnError
  >({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/ai/exemplar/import',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Archive Profile
 */
export const archiveProfile = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<ArchiveProfileResponse, unknown, ThrowOnError>({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/ai/profile/{profile_key}',
    ...options,
  })
}

/**
 * Get Profile By Key
 */
export const getProfileByKey = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileByKeyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<GetProfileByKeyResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai/profile/{profile_key}',
    ...options,
  })
}

/**
 * Create Or Update Profile
 * Create a new profile or update existing one.
 *
 * The profile_key must be unique within the customer context.
 */
export const createOrUpdateProfile = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrUpdateProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, CreateOrUpdateProfileError, ThrowOnError>({
    security: [
      {
        name: 'X-API-Key',
        type: 'apiKey',
      },
    ],
    url: '/api/ai/profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Generate V2
 */
export const generateV2 = <ThrowOnError extends boolean = false>(
  options: Options<GenerateV2Data, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<GenerateV2Response, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/ai/generate-v2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}
